import commonJson from "@/data/copy/common.json";
import { createCopyGetter } from "./localize-copy";

export const getCommonCopy = createCopyGetter(commonJson);
